'use client';

import { useState } from 'react';

interface ImageItem {
	id: string;
	file: File;
	preview: string;
	result: string;
	loading: boolean;
}

export default function MultiOcrPage() {
	const [images, setImages] = useState<ImageItem[]>([]);
	const [isAgentModel, setAgentModel] = useState<string>("gemini-3.5-flash");
	const [isLayerPopupView, setLayerPopupView] = useState<boolean>(false);

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (!e.target.files) return;
		
		const files = Array.from(e.target.files);
		const newItems = files.map(file => ({
			id: crypto.randomUUID(), // 고유 ID 부여
			file,
			preview: URL.createObjectURL(file),
			result: '',
			loading: false
		}));
		
		setImages(prev => [...prev, ...newItems]);
		e.target.value = '';
	};

	const removeImage = (id:string) => {
		setImages(prev => {
			const target = prev.find(img => img.id === id);
			if (target) URL.revokeObjectURL(target.preview);
			return prev.filter(img => img.id !== id);
		});
	};

	const extractText = async (id: string) => {
		const target = images.find(img => img.id === id);
		if (!target || target.loading) return;

		setImages(prev => prev.map(img => 
			img.id === id ? { ...img, loading: true, result: '' } : img
		));

		const reader = new FileReader();
		reader.readAsDataURL(target.file);
		reader.onload = async () => {
			const base64Data = (reader.result as string).split(',')[1];

			try {
				const res = await fetch('/api/gemini', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ imageBase64: base64Data, googleAgentModel: isAgentModel }),
				});
				
				const data = await res.json();

				setImages(prev => prev.map(img =>
					img.id === id ? { ...img, result: data.text || data.error, loading: false } : img
				));

			} catch (err) {
				setImages(prev => prev.map(img =>
					img.id === id ? { ...img, loading: false, result: '서버 통신 실패' } : img
				));
			}
		};
	};

	const HandleCopyText = async (text : string) =>{
		if(!text) {
			alert("복사할 텍스트가 없습니다.")
			return;
		};
		
		try {
			await navigator.clipboard.writeText(text.replace(/\s+/g, ' ').trim());
			setLayerPopupView(true);

			setTimeout(() => {
				setLayerPopupView(false);
			}, 500);
		} catch (err) {
			console.error('클립보드 복사 실패:', err);
		}
	}

	return (
		<>
		<div className="model-choice">
			<select id="agent" onChange={(e) => setAgentModel(e.target.value)} value={isAgentModel} className="selectbox">
				<option value="gemma-4-31b-it">젬마 4 / 31b / it (1500회)</option>
				<option value="gemini-2.5-flash">Gemini 2.5 flash (500회)</option>
				<option value="gemini-3.1-flash-lite">Gemini 3.1 Flash Lite (500회)</option>
				<option value="gemini-3.5-flash">Gemini 3.5 flash (기본값) (20회)</option>
			</select>
		</div>

		<div className="file-upload">
			<input type="file" multiple onChange={handleFileChange} />
			<p className="comment-text">이미지를 여러 개 선택하거나 추가로 넣을 수 있습니다.</p>
			<p className="comment-text">텍스트의 양이 많은 경우, 시간이 많이 소요되어 통신 오류가 발생할 수 있으니 여러개로 쪼개어 활용해주시기 바랍니다.</p>
			<p className="comment-text">이미지에 있는 텍스트와 완전 동일하게 나오지 않을 수 있으며, 글자체나 이미지의 품질에 따라 인식률이 달라질 수 있습니다.</p>
		</div>

		<div className="preview-content">
			{
				images.length ? images.map((item, index) => (
					<>
					<div id={item.id} key={item.id} className="item-preview">
						<strong className="index">{index + 1}</strong>
						<div className="btn-group">
							<button type="button" className="btn-primary-delete" onClick={() => removeImage(item.id)}>삭제</button>
							<button type="button" className="btn-primary" onClick={() => extractText(item.id)} disabled={item.loading}>{item.loading ? '분석 중...' :'텍스트 추출'}</button>
						</div>

						<div className="item-preview-container">
							<div className="item-preview-image">
								<img src={item.preview} alt="미리보기" style={{ width:'100%',display:'block',marginBottom:'10px' }} />
							</div>

							<div className="item-preview-text">
								<strong className="name">추출 결과 : </strong>
								<div className="view">
									{item.result || (item.loading ? '분석하는 중입니다...' :'')}
								</div>
								<button type="button" className="btn-primary-copy" onClick={()=> HandleCopyText(item.result)}>텍스트 복사</button>
							</div>
						</div>
					</div>
					</>
				))
				:
				<p className="no-contents">첨부된 이미지가 없습니다.</p>
			}
		</div>

		{
			isLayerPopupView && 
			<>
			<div className="view-opacity"></div>
			<p className="copy-note">추출된 텍스트가 복사되었습니다.</p>
			</>
		}
		</>
	);
}